import { render, staticRenderFns } from "./returnpurchase.vue?vue&type=template&id=0710692e&"
import script from "./returnpurchase.vue?vue&type=script&lang=js&"
export * from "./returnpurchase.vue?vue&type=script&lang=js&"
import style0 from "./returnpurchase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports